// Module
var code = "<div id=\"content\" class=\"visualiser-list-item\">\n    <div class=\"title-bar\">\n        <h4 id=\"name\">{{ name }}</h4>\n        <button id=\"remove\" type=\"button\">Ｘ</button>\n    </div>\n</div>";
// Exports
module.exports = code;